import { cn } from '@listening/utils/react-helpers';
import { Spinner } from './spinner';

export function LoadingComponent({
  className,
  spinnerClassName,
}: {
  className?: string;
  spinnerClassName?: string;
}) {
  return (
    <div
      className={cn(
        'flex h-full w-full flex-col items-center justify-center',
        className,
      )}
    >
      <Spinner className={spinnerClassName} />
    </div>
  );
}
